import React from "react";
import { AddEligibilityContainer } from "../../../containers";

const AddEligibility = (props) => {
  return <AddEligibilityContainer {...props} />;
};

export default AddEligibility;
